module.exports = __webpack_public_path__ + "img/trash.7f116971.svg";